// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAB7lqpzFOYldsXJoGJAzMyDMpSVcE7ruc",
  authDomain: "bazarapp-209bb.firebaseapp.com",
  projectId: "bazarapp-209bb",
  storageBucket: "bazarapp-209bb.appspot.com",
  messagingSenderId: "280016234308",
  appId: "1:280016234308:web:296ca5e3e3ccfdc76e5911",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
